module.exports = "pegasus_template/assets/email1-img13.png";